import { render, staticRenderFns } from "./MailchimpSignupForm.vue?vue&type=template&id=6c68aec0&scoped=true"
import script from "./MailchimpSignupForm.vue?vue&type=script&lang=js"
export * from "./MailchimpSignupForm.vue?vue&type=script&lang=js"
import style0 from "./MailchimpSignupForm.vue?vue&type=style&index=0&id=6c68aec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68aec0",
  null
  
)

export default component.exports